module.exports = __webpack_public_path__ + "media/application/images/icons/download-file-green-b95d21824712e4c3add45211d199037b.svg";